module.exports = __webpack_public_path__ + "media/1-2视频.cd617841.mp4";